import type { PropsWithChildren, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { useMediaQuery } from 'shared/hooks/use-match-media'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

export const CourseQuizScreenWrapper = ({
  className,
  children,
}: PropsWithChildren<{
  className?: string
}>): ReactNode => {
  const isLG = useMediaQuery('(min-width: 1024px)', false)

  const publicCustomClassNamePrefix = addPublicCustomClassNamePrefix('course__quiz-results-screen')

  return (
    <div className={twMerge('basis-full', className, publicCustomClassNamePrefix)}>
      <div
        className="mt-10 flex w-full flex-col items-center justify-center lg:mt-0"
        style={{ transform: isLG ? 'translateY(min(100vh, 50vh - 100%))' : '' }}
      >
        {children}
      </div>
    </div>
  )
}
